import CButton from '01_core/components/materials/CButton';
import CCheckBox from '01_core/components/materials/CCheckBox';
import ResourceHtml from '01_core/components/materials/ResourceHtml';
import React from 'react';
import { connect } from 'react-redux';

import { styled } from '@mui/material/styles';

import { TYPES, loginActions } from '../loginActions';

const StyledButtonWrap = styled('div')({
  marginTop: 20,
  textAlign: 'right',
});

const StyledButtonAgree = styled(CButton)({
  marginLeft: 10,
});

class PrivacyPolicy extends React.Component {
  buttonActive = (pushed) => {
    this.props.buttonChecked('isCheck', pushed);
    this.props.buttonChecked('isButtonActive', !pushed);
  };

  render() {
    const { state, onOkClick, onCancelClick } = this.props;
    return (
      <React.Fragment>
        OneNEC 事業継続支援システムは、
        <br />
        以下の個人情報の取り扱いについてご同意いただいた上でご利用いただけます。
        <hr />
        <ResourceHtml id='privacy_policy' />
        <hr />
        上記の個人情報取り扱い方針に同意しますか？ <br />
        <StyledButtonWrap>
          <CCheckBox
            label='個人情報取り扱い方針に同意します'
            onChange={(pushed) => this.buttonActive(pushed)}
            checked={state.isCheck}
            color='secondary'
          />
          <CButton negative onClick={onCancelClick} autoWidth>
            同意しない
          </CButton>
          <StyledButtonAgree onClick={onOkClick} disabled={state.isButtonActive} autoWidth>
            同意する
          </StyledButtonAgree>
        </StyledButtonWrap>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  state: state.commonLogin,
});
const mapDispatchToProps = (dispatch) => ({
  buttonChecked: (key, value) => dispatch(loginActions[TYPES.SET_BUTTON_CHECKED](key, value)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivacyPolicy);